var _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSamiFlag(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "30px",
    height: "27px",
    viewBox: "0 0 1295.5 1159",
    style: {
      enableBackground: "new 0 0 1295.5 1159"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M0,579.5c0,241.4,165,448.3,399.6,535.5V44C165,131.1,0,338.1,0,579.5z",
    fill: "#D81E05"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.6,44V1115c44.4,16.5,91.3,28.7,140,36V8C490.9,15.4,444,27.6,399.6,44z",
    fill: "#007A3D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M647.7,0c-36.8,0-72.9,2.8-108.1,8V1151c35.2,5.3,71.3,8,108.1,8c10.7,0,21.3-0.2,31.9-0.7V0.7   C669.1,0.2,658.4,0,647.7,0z",
    fill: "#FCD116"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M679.6,0.7v1157.6c342.9-14.9,615.8-268.3,615.8-578.8S1022.6,15.6,679.6,0.7z",
    fill: "#0038A8"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M539.6,136.7c-243,0-440,197-440,440s197,440,440,440",
    fill: "none",
    stroke: "#0038A8",
    strokeWidth: 80
  }), /*#__PURE__*/React.createElement("path", {
    d: "M539.6,136.7c243,0,440,197,440,440s-197,440-440,440",
    fill: "none",
    stroke: "#D81E05",
    strokeWidth: 80
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSamiFlag);
export default __webpack_public_path__ + "static/media/samiFlag.297e738783be8e678949641da55c1b47.svg";
export { ForwardRef as ReactComponent };